<template>
  <div id="indexBox" v-show="indexShow">
    <el-container class="wmCloudsWrapper">
      <app-header></app-header>
      <!--<router-view></router-view>-->
      <el-container id="mainLayoutBox" class="flexbox">
        <div ref="keepAliveContainer" class="el-container" style="flex: 1">
          <!--<keep-alive include="newRead">-->
            <!--<router-view :key="$route.fullPath"></router-view>-->
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
          <!--</keep-alive>-->
        </div>
        <page-tabs :keep-alive-component-instance="keepAliveComponentInstance" v-show="tabsShow" :tabsShow.sync="tabsShow" />
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import { loginByEmail } from '@/api/login';
  import { rsaEncrypt } from '@/utils/utils';
  import AppHeader from '@/components/sub/Header.vue'
  import AppFooter from '@/components/sub/Footer.vue'
  import asideSet from '@/components/sub/asideSet.vue'
  import setBreadNav from '@/components/sub/setBreadNav.vue'
  import listBar from '@/components/sub/listBar.vue'
  import pageTabs from "@/components/sub/pageTabs.vue"
  import setComponent from "@/components/views/setBox/setComponent"
  import MainHome from "@/components/views/layout/MainHome"
  import MainSetting from "@/components/views/layout/MainSetting"
  import storeLocal from 'store';
  import xmail from '@/api/api';
  import Cookies from 'js-cookie';
  import OrgContacts from "../../core/common/OrgContacts";

  export default {
    name: 'indexBox',
    data () {
      return {
        orgInfoListData: [],
        keepAliveComponentInstance: null,
        tabsShow: false,
        indexShow: true,
        gap_time: 0,
        beforeUnload_time: 0
      }
    },
    components:{
      setComponent,
      asideSet,
      setBreadNav,
      pageTabs,
      listBar,
      'app-header': AppHeader,
      'app-footer': AppFooter,
      MainHome,
      MainSetting
    },
    mounted() {
      // if (this.$route.query) {
      //   console.log(this.$route.query.user);
      //   console.log(this.$route.query.password);
      // }
      // this.indexShow = !!storeLocal.get('Pwm-Islogin');
      window.addEventListener('beforeunload', e => this.beforeunloadHandler(e));
      window.addEventListener('unload', e => this.unloadHandler(e));

      // console.log(storeLocal.get('Pwm-password'));
      // console.log(Cookies.get('Pwm-userInfo-sso'));

      if(Cookies.get('Pwm-userInfo-sso')) {
        // let self = this;
        // setTimeout(function () {
        //   //单点跳转读信
        //   // self.$router.push({name:'read',params: {isAnnounce: true, id:'e3557337d84046989998dab511e5d49a', fileId:'7597f66ab1d4456a8863c7b00c0cdff0', folderId: 1, read:true},query: { t: Date.now() }})
        //   //单点跳转（已登录）
        //   self.initPage();
        // }, 300);

        let ssoData = JSON.parse(decodeURIComponent(Cookies.get('Pwm-userInfo-sso')));
        storeLocal.set('Pwm-Islogin', ssoData.sid);
        storeLocal.set('Pwm-userInfo', ssoData);
        // 后端请求的URL参数用主域名账号
        storeLocal.set('Pwm-urlParams', '?sid='+ ssoData.sid +'&loginAppType='+ ssoData.loginAppType +'&user='+ssoData.primeUserEmail);
        storeLocal.set('Pwm-password','ssoLogin');
        this.$store.commit('SET_USER', ssoData.userEmail);

        let self = this;
        (function (api, enums, pms) {
          api.Home.homeSetting({}, function (res) {
            if(res.data.code === 0) {
              // console.log(res.data.data)
              window.document.title = res.data.data.displaySetting.customTitle ? res.data.data.displaySetting.customTitle : this.$i18n.t('wm_lang_d7c0a1');
              let configSetting = storeLocal.get('Pwm-configSetting');
              if(configSetting) {//多语言强制刷新
                if(res.data.data.displaySetting.language !== configSetting.displaySetting.language) {
                  storeLocal.set('Pwm-configSetting', res.data.data);
                  window.location.href = window.location.protocol + "//" + window.location.host;
                }
              }
              storeLocal.set('Pwm-configSetting', res.data.data);
              if(res.data.data.displaySetting.layout === enums.Layout.LR) {
                Cookies.set('Pwm-set-layout','lr');
              } else {
                Cookies.set('Pwm-set-layout','tb');
              }
              //layout初始化
              self.initPage();
              //文件夹初始化
              self.$EventBus.$emit("getInitFolder");
              //首页初始化
              self.$EventBus.$emit("getInitHome");
              //页头初始化
              self.$EventBus.$emit("getInitHeader");
              // self.$router.push({ path: '/' });

              if(ssoData.isClickMsg) {
                setTimeout(function () {
                  //单点跳转读信
                  self.$router.push({name:'newRead',params: {isAnnounce: true, id:ssoData.mailIndexId, fileId:ssoData.fileId, read:false, isClickMsg:true},query: { t: Date.now() }})
                }, 300);
              }

            }
          })
        })(xmail.api, xmail.enums, xmail.pms);

        //清除单点登录信息
        Cookies.remove('Pwm-userInfo-sso', { path: '/', domain: '.'+ window.location.host });
        // Cookies.remove('Pwm-userInfo-sso'); //开发环境删除单点信息cookie
        // console.log('-----单点登录完成完成完成完成完成完成完成完成完成完成完成完成完成完成完成完成完成完成完成完成完成完成完成-----');
        return;
      }
      // console.log('-----常规登录逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑逻辑-----');
      if(!storeLocal.get('Pwm-Islogin')) {
        this.indexShow = false;
        if(!storeLocal.get('Pwm-password')) {
          // this.$router.push({path: '/login'});
          window.location.href = window.location.protocol + "//" + window.location.host + "/login/";
          return;
        }
        loginByEmail(storeLocal.get('Pwm-user'), storeLocal.get('Pwm-password'), xmail.enums.ClientType.WM_PC, true).then(response => {
          // console.log(this.$route.query.user);
          const data = response.data;
          // console.log(data);
          // return;
          if(data.code === 0) {
            this.indexShow = true;
            storeLocal.set('Pwm-Islogin', data.data.sid);
            storeLocal.set('Pwm-userInfo', data.data);
            // storeLocal.set('Pwm-urlParams', '?sid='+ data.data.sid +'&loginAppType='+ data.data.loginAppType +'&user='+data.data.userEmail);
            // 后端请求的URL参数用主域名账号
            storeLocal.set('Pwm-urlParams', '?sid='+ data.data.sid +'&loginAppType='+ data.data.loginAppType +'&user='+data.data.primeUserEmail);
            this.$store.commit('SET_USER', data.data.userEmail);
            // this.$store.commit('SET_ISLOGIN', data.data.sid);
            // this.$store.commit('SET_USER', data.data.userEmail);
            // this.$store.commit('SET_SID', data.data.sid);
            // this.$store.commit('SET_LOGIN_TYPE', data.data.loginAppType);


            let self = this;
            (function (api, enums, pms) {
              api.Home.homeSetting({}, function (res) {
                if(res.data.code === 0) {
                  // console.log(res.data.data)
                  window.document.title = res.data.data.displaySetting.customTitle ? res.data.data.displaySetting.customTitle : this.$i18n.t('wm_lang_d7c0a1');
                  let configSetting = storeLocal.get('Pwm-configSetting');
                  if(configSetting) {//多语言强制刷新
                    if(res.data.data.displaySetting.language !== configSetting.displaySetting.language) {
                      storeLocal.set('Pwm-configSetting', res.data.data);
                      window.location.href = window.location.protocol + "//" + window.location.host;
                    }
                  }
                  storeLocal.set('Pwm-configSetting', res.data.data);
                  if(res.data.data.displaySetting.layout === enums.Layout.LR) {
                    Cookies.set('Pwm-set-layout','lr');
                  } else {
                    Cookies.set('Pwm-set-layout','tb');
                  }
                  //layout初始化
                  self.initPage();
                  //文件夹初始化
                  self.$EventBus.$emit("getInitFolder");
                  //首页初始化
                  self.$EventBus.$emit("getInitHome");
                  //页头初始化
                  self.$EventBus.$emit("getInitHeader");
                  // self.$router.push({ path: '/' });
                }
              })
            })(xmail.api, xmail.enums, xmail.pms);
            // this.$router.push({ path: '/' });

            this.loading = false;
          } else {
            storeLocal.remove('Pwm-Islogin');
            storeLocal.remove('Pwm-user');
            // storeLocal.remove('Pwm-password');
            let eCode = xmail.enums.ErrorCode;
            //二次验证------------start----------
            if(data.code === xmail.enums.ErrorCode.UDR_SECURE_LOGIN) {
              storeLocal.set('Pwm-urlParams', '?sid='+ data.data.sid +'&loginAppType='+ data.data.loginAppType +'&user='+data.data.primeUserEmail);
              this.$router.push({name: 'SecondVerify', params: { errorData: data}});
              return;
            }
            storeLocal.remove('Pwm-password');
            //二次验证----------end----------
            // console.log(data.code === xmail.enums.ErrorCode.WM_PASSWORD_WEAK_ERROR)
            if(data.code === eCode.WM_PASSWORD_WEAK_ERROR || data.code === eCode.UDR_USER_PASSWORD_WEAK_ERROR || data.code === eCode.UDR_USER_PASSWORD_FIRST_ERROR || data.code === eCode.UDR_USER_PASSWORD_CYCLE_ERROR) {
              storeLocal.set('Pwm-urlParams', '?sid='+ data.data.sid +'&loginAppType='+ data.data.loginAppType +'&user='+data.data.primeUserEmail);
              storeLocal.set('Pwm-passwordRule', {...data.data.corpRulePasswd,...{pwType:data.code}});
              this.$router.push({name: 'ChangePw', params: { errorData: data}});
            } else {
              if(data.msgVals && JSON.stringify(data.msgVals) !== '{}'){
                this.$router.push({name: 'Error', query: {code:data.code, host:data.host, time:data.time, traceId:data.traceId , webLanguage:data.data ? data.data.webLanguage : '', msgVals:JSON.stringify(data.msgVals) }});
              } else {
                this.$router.push({name: 'Error', query: {code:data.code, host:data.host, time:data.time, traceId:data.traceId , webLanguage:data.data ? data.data.webLanguage : '' }});
              }
            }
          }
        }).catch(error => {
          // this.$message.error(error);
          this.loading = false;
          console.log(error)
        });
      } else {
        if(storeLocal.get('Pwm-secondVerify')) { //由登录二次验证跳转
          storeLocal.remove('Pwm-secondVerify');
          let self = this;
          (function (api, enums, pms) {
            api.Home.homeSetting({}, function (res) {
              if(res.data.code === 0) {
                // console.log(res.data.data)
                window.document.title = res.data.data.displaySetting.customTitle ? res.data.data.displaySetting.customTitle : this.$i18n.t('wm_lang_d7c0a1');
                let configSetting = storeLocal.get('Pwm-configSetting');
                if(configSetting) {//多语言强制刷新
                  if(res.data.data.displaySetting.language !== configSetting.displaySetting.language) {
                    storeLocal.set('Pwm-configSetting', res.data.data);
                    window.location.href = window.location.protocol + "//" + window.location.host;
                  }
                }
                storeLocal.set('Pwm-configSetting', res.data.data);
                if(res.data.data.displaySetting.layout === enums.Layout.LR) {
                  Cookies.set('Pwm-set-layout','lr');
                } else {
                  Cookies.set('Pwm-set-layout','tb');
                }
                //layout初始化
                self.initPage();
                //文件夹初始化
                self.$EventBus.$emit("getInitFolder");
                //首页初始化
                self.$EventBus.$emit("getInitHome");
                //页头初始化
                self.$EventBus.$emit("getInitHeader");
                // self.$router.push({ path: '/' });
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        } else {
          this.initPage();
        }
        // this.initPage();
      }


      // if (this.$refs.keepAliveContainer) {
      //   this.keepAliveComponentInstance = this.$refs.keepAliveContainer.childNodes[0].__vue__;
      // }
      // // 刷新页面跳转首页(并关闭多页签)
      // if(this.$route.name === 'write') {
      //   // 在写信页刷新浏览器，直接执行路由跳转会导致keep-alive组件缓存导致tinymce-editor编辑器初始化报错
      //   this.$router.push({path: '/'});
      //   let protocol = window.location.protocol;
      //   let domain = window.location.host;
      //   window.location.href = protocol + "//" + domain;
      // } else {
      //   this.$router.push({path: '/'});
      // }
      // this.tabsShow = false;
      //
      // this.getHomeSetting();
      //
      // let self = this;
      // //获取HomeSetting事件总线
      // this.$EventBus.$off("getConfigSetting");
      // this.$EventBus.$on("getConfigSetting",function(){
      //   self.getHomeSetting();
      // });
      // //获取个人通讯录数据，并存储个人通讯录信息数据
      // let persVersion = storeLocal.get('ls_pers_version');
      // // console.log(persVersion);
      // OrgContacts.getPersAddressTrees(function (nodes) {
      //   // console.log(nodes);
      //   if(!nodes) {
      //     return;
      //   }
      //   let perVer = nodes.contactVersion;
      //   // console.log(perVer)
      //   let persNodes = [];
      //   if(!nodes.versionChange) {
      //     persNodes = storeLocal.get('ls_pers_address') ? storeLocal.get('ls_pers_address') : self.$store.getters.persAddress;
      //     // console.log('store:')
      //     // console.log(persNodes)
      //     self.persInfoMap(persNodes);
      //   } else {
      //     persNodes = nodes.userContactTrees;
      //     // console.log(persNodes)
      //     storeLocal.set('ls_pers_version', perVer);
      //     try {
      //       storeLocal.set('ls_pers_address', persNodes);
      //     } catch (e) {
      //       self.$store.commit('SET_PERS_ADDRESS',persNodes);
      //     }
      //     self.persInfoMap(JSON.parse(JSON.stringify(persNodes)));
      //   }
      // }, persVersion);
      // //获取组织通讯录数据，并存储组织通讯录信息数据
      // let orgVersion =  storeLocal.get('ls_org_version');
      // OrgContacts.getCorpOrgTrees(function (nodes) {
      //   // console.log(nodes);
      //   let orgVer = nodes.version;
      //   let orgNodes = [];
      //   // console.log(orgVer)
      //   // console.log(orgVersion)
      //   if(orgVer === orgVersion) {
      //     orgNodes = storeLocal.get('ls_org_address') ? storeLocal.get('ls_org_address') : self.$store.getters.orgAddress;
      //     // console.log('store:')
      //     // console.log(orgNodes)
      //     self.orgInfoMap(JSON.parse(JSON.stringify(orgNodes)));
      //   } else {
      //     orgNodes = nodes.orgTrees;
      //     storeLocal.set('ls_org_version', orgVer);
      //     try {
      //       storeLocal.set('ls_org_address', orgNodes);
      //     } catch (e) {
      //       self.$store.commit('SET_ORG_ADDRESS',orgNodes);
      //     }
      //     self.orgInfoMap(JSON.parse(JSON.stringify(orgNodes)));
      //   }
      // });
    },
    destroyed() {
      window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e));
      window.removeEventListener('unload', e => this.unloadHandler(e));
    },
    methods: {
      beforeunloadHandler(){
        this.beforeUnload_time = new Date().getTime();
      },
      unloadHandler(e){
        this.gap_time = new Date().getTime() - this.beforeUnload_time;
        // debugger
        //判断是窗口关闭还是刷新
        if(this.gap_time <= 5){
          //登录状态，关闭窗口前删除登录状态标识
          storeLocal.remove('Pwm-Islogin');
          storeLocal.remove('Pwm-user');
          storeLocal.remove('Pwm-password');
        }
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      initPage() {
        if (this.$refs.keepAliveContainer) {
          this.keepAliveComponentInstance = this.$refs.keepAliveContainer.childNodes[0].__vue__;
        }
        try {
          let configSetting = storeLocal.get('Pwm-configSetting');
          let loginRouterPage = configSetting ? configSetting.displaySetting.loginRouterPage : 1;
          //获取首页信息数据  账号安全-信任登录地点需要用到 当前登录地点及ip
          if (storeLocal.get('Pwm-Islogin')) {
            (function (api, enums, pms) {
              api.Home.homeInfo({}, function (res) {
                if(res.data.code === 0) {
                  storeLocal.set('Pwm-homeInfo', res.data.data);
                }
              })
            })(xmail.api, xmail.enums, xmail.pms);
          }
          if(loginRouterPage === 1) {
            this.$router.push({ path: '/home/info' });
          } else {
            this.$router.push({ path: '/home/mail' });
          }
        } catch (e) {
          console.log(e)
        }
        // 刷新页面跳转首页(并关闭多页签)
        console.log(this.$route.name);
        this.$EventBus.$emit("clearWriteKeepAlive");
        // if(this.$route.name === 'write') {
        //   // 在写信页刷新浏览器，直接执行路由跳转会导致keep-alive组件缓存导致tinymce-editor编辑器初始化报错
        //   // this.$router.push({path: '/'});
        //   let protocol = window.location.protocol;
        //   let domain = window.location.host;
        //   window.location.href = protocol + "//" + domain;
        // } else {
        //   // this.$router.push({path: '/'});
        // }
        this.tabsShow = false;

        // this.getHomeSetting();

        let self = this;
        //获取HomeSetting事件总线
        this.$EventBus.$off("getConfigSetting");
        this.$EventBus.$on("getConfigSetting",function(){
          self.getHomeSetting();
        });
        //获取个人通讯录数据，并存储个人通讯录信息数据
        let persVersion = storeLocal.get('ls_pers_version');
        // console.log(persVersion);
        OrgContacts.getPersAddressTrees(function (nodes) {
          // console.log(nodes);
          if(!nodes) {
            return;
          }
          let perVer = nodes.contactVersion;
          // console.log(perVer)
          let persNodes = [];
          if(!nodes.versionChange) {
            persNodes = storeLocal.get('ls_pers_address') ? storeLocal.get('ls_pers_address') : self.$store.getters.persAddress;
            // console.log('store:')
            // console.log(persNodes)
            self.persInfoMap(persNodes);
          } else {
            persNodes = nodes.userContactTrees;
            // console.log(persNodes)
            storeLocal.set('ls_pers_version', perVer);
            try {
              storeLocal.set('ls_pers_address', persNodes);
            } catch (e) {
              self.$store.commit('SET_PERS_ADDRESS',persNodes);
            }
            self.persInfoMap(JSON.parse(JSON.stringify(persNodes)));
          }
        }, persVersion);
        //获取组织通讯录数据，并存储组织通讯录信息数据
        let orgVersion =  storeLocal.get('ls_org_version');
        OrgContacts.getCorpOrgTrees(function (nodes) {
          // console.log(nodes);
          let orgVer = nodes.version;
          let orgNodes = [];
          // console.log(orgVer)
          // console.log(orgVersion)
          if(orgVer === orgVersion) {
            orgNodes = storeLocal.get('ls_org_address') ? storeLocal.get('ls_org_address') : self.$store.getters.orgAddress;
            // console.log('store:')
            // console.log(orgNodes)
            self.orgInfoMap(JSON.parse(JSON.stringify(orgNodes)));
          } else {
            orgNodes = nodes.orgTrees;
            storeLocal.set('ls_org_version', orgVer);
            try {
              storeLocal.set('ls_org_address', orgNodes);
            } catch (e) {
              self.$store.commit('SET_ORG_ADDRESS',orgNodes);
            }
            self.orgInfoMap(JSON.parse(JSON.stringify(orgNodes)));
          }
        }, orgVersion);
      },
      getHomeSetting() {
        //获取默认设置数据
        (function (api, enums, pms) {
          api.Home.homeSetting({}, function (res) {
            if(res.data.code === 0) {
              // console.log(res.data.data)
              window.document.title = res.data.data.displaySetting.customTitle ? res.data.data.displaySetting.customTitle : this.$i18n.t('wm_lang_d7c0a1');
              storeLocal.set('Pwm-configSetting', res.data.data);
              if(res.data.data.displaySetting.layout === enums.Layout.LR) {
                Cookies.set('Pwm-set-layout','lr');
              } else {
                Cookies.set('Pwm-set-layout','tb');
              }
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      },
      persInfoMap(persNodes) {
        console.log(persNodes)
        let persInfo = persNodes[0].children ? persNodes[0].children : [];
        storeLocal.set('ls_pers_info', persInfo);
        // let per = persInfo.find(item => item.email === 'lingzhi.li@sdfsd.com');
      },
      treeToList(data) {
        data.forEach(item => {
          if(item.children && item.children.length > 0) {
            this.treeToList(item.children);
          }
          if(data.type !== 2) {
            this.orgInfoListData.push(item);
          }
        });
      },
      orgInfoMap(orgNodes) {
        // console.log(orgNodes)
        this.treeToList(orgNodes);
        // console.log(this.orgInfoListData);
      }
    }
  }
</script>

<style scoped>
  .wmCloudsWrapper{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/layout/index.vue